import React from "react";
import GraphIconButton from "../components/buttons/GraphIconButton";
import { dollarFormat, roundFormat } from "../utils/formatting";

const sumYearValues = (obj) => {
    if (!obj || typeof obj !== "object") return obj || 0;
    return Object.values(obj).reduce((sum, val) => {
        if (typeof val === "number") return sum + val;
        if (typeof val === "object" && val !== null) return sum + sumYearValues(val);
        return sum;
    }, 0);
};

const YearBreakdownMetric = ({ 
    label, 
    yearData, 
    isDollars, 
    graphLabelX, 
    graphLabelY, 
    openModalFn, 
    accessorFn, 
    data 
}) => {
    const formatValue = (val) => {
        if (typeof val === "object" && val !== null) {
            return isDollars ? dollarFormat(sumYearValues(val)) : roundFormat(sumYearValues(val));
        }
        return isDollars ? dollarFormat(val) : roundFormat(val);
    };

    if (!yearData || typeof yearData !== "object") {
        return (
            <p>
                <strong>
                    {label}:
                    {openModalFn && (
                        <GraphIconButton
                            onClick={() => openModalFn(label, graphLabelX, graphLabelY, accessorFn, data)}
                        />
                    )}
                </strong>{" "}
                {isDollars ? dollarFormat(yearData) : roundFormat(yearData)}
            </p>
        );
    }

    const years = Object.keys(yearData).sort();

    return (
        <div className="mb-2">
            <strong>
                {label}:
                {openModalFn && (
                    <GraphIconButton
                        onClick={() => openModalFn(label, graphLabelX, graphLabelY, accessorFn, data)}
                    />
                )}
            </strong>
            <table className="ml-4 mt-1">
                <tbody>
                    {years.map((year) => (
                        <tr key={year}>
                            <th className="text-left pr-3 font-medium">{year}</th>
                            <td>{formatValue(yearData[year])}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export { sumYearValues };
export default YearBreakdownMetric;
